/**
 * Where new contacts come from, named wherever a call cannot add one
 * (`save_contact`, `send_email`'s inline `to`): those keep consent where a
 * person opts in. One phrase, so every surface names the same flows.
 */
export const NEW_CONTACT_SOURCES =
  'a contact import (`import_contacts`, `import_contacts_csv` or the in-app CSV upload), a connected integration or your own sign-up flow on the Brew API'
